export const DEFAULT_INSIDE_SPACE_LOGO_SIZE_PX = 204;
export const MIN_INSIDE_SPACE_LOGO_SIZE_PX = 80;
export const MAX_INSIDE_SPACE_LOGO_SIZE_PX = 400;

export const DEFAULT_INSIDE_SPACE_PADDING_PX = 24;
export const MIN_INSIDE_SPACE_PADDING_PX = 0;
export const MAX_INSIDE_SPACE_PADDING_PX = 80;

export function parseInsideSpaceLogoSizePx(value: unknown): number | undefined {
    const parsed =
        typeof value === 'number'
            ? value
            : typeof value === 'string' && value.trim()
              ? Number.parseInt(value, 10)
              : Number.NaN;

    if (!Number.isFinite(parsed)) {
        return undefined;
    }

    const rounded = Math.round(parsed);
    if (rounded < MIN_INSIDE_SPACE_LOGO_SIZE_PX || rounded > MAX_INSIDE_SPACE_LOGO_SIZE_PX) {
        return undefined;
    }

    return rounded;
}

export function parseInsideSpacePaddingPx(value: unknown): number | undefined {
    const parsed =
        typeof value === 'number'
            ? value
            : typeof value === 'string' && value.trim()
              ? Number.parseInt(value, 10)
              : Number.NaN;

    if (!Number.isFinite(parsed)) {
        return undefined;
    }

    const rounded = Math.round(parsed);
    if (rounded < MIN_INSIDE_SPACE_PADDING_PX || rounded > MAX_INSIDE_SPACE_PADDING_PX) {
        return undefined;
    }

    return rounded;
}
